/**
 * サービスレベル検索用の日付フォーマット関数
 * 日付文字列を「YYYY年MM月DD日(曜)」形式に変換します
 */
export const formatDateWithWeekday = (dateStr: string): string => {
  if (!dateStr) return ''

  // 曜日の配列（日本語表記）
  const weekdays = ['日', '月', '火', '水', '木', '金', '土']

  // 日付オブジェクトを取得
  const date = $core.$dayjs(dateStr)

  // 曜日を取得（0:日曜、1:月曜、...6:土曜）
  const weekdayIndex = date.day()

  // 「YYYY年MM月DD日(曜)」形式でフォーマット
  return date.format('YYYY年M月D日') + `(${weekdays[weekdayIndex]})`
}
